import { Component, OnInit } from '@angular/core';
import { faPencilAlt, faSearch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Filter } from 'src/app/shared/models/filter.model';
import { Observable } from 'rxjs';
import { BranchOfficeService } from 'src/app/shared/services/admin-services/branch-office.service';
import { BranchOffices } from 'src/app/shared/models/admin-models/branch-offices.model';

@Component({
  selector: 'app-branch-offices',
  templateUrl: './branch-offices.component.html',
  styleUrls: ['./branch-offices.component.sass']
})
export class BranchOfficesComponent implements OnInit {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;
  faCheck = faCheck;
  faTimes = faTimes;

  addOrEditBool: Boolean = true;
  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} })
  lookupId: Number;
  lookupArray: BranchOffices[] = [];
  total: number = 0

  filterForm = new FormGroup({
    name: new FormControl('', [])
  })

  lookupForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    agency: new FormControl(false)
  })

  constructor(private modalService: NgbModal, private branchOfficeService: BranchOfficeService) { }

  ngOnInit() {
    this.getAll()
  }

  getAll() {
    this.filter.data.Filter = {}
    if (this.filterForm.value.name)
      this.filter.data.Filter.Name = this.filterForm.value.name

    this.branchOfficeService.gridView(this.filter)
      .subscribe(
        x => {
          this.lookupArray = x.data
          this.total = x.total
        },
        e => console.log(e)
      )

  }

  openAddLookupModal(modal) {
    this.lookupForm.reset({ agency: false });
    this.addOrEditBool = true;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  addLookup() {
    let lookup = new BranchOffices({ Name: this.lookupForm.value.name, Agency: this.lookupForm.value.agency })
    this.branchOfficeService.createBranchOffice(lookup)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openEditLookupModal(modal, id) {
    this.addOrEditBool = false;
    this.branchOfficeService.getOne(id)
      .then(
        (x: { id: Number, name: String, agency: Boolean }) => {
          this.lookupId = id;
          this.lookupForm.get('name').setValue(x.name);
          this.lookupForm.get('agency').setValue(x.agency);
          this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
        }
      )
  }
  editLookup() {
    let lookup = new BranchOffices({ Id: this.lookupId, Name: this.lookupForm.value.name, Agency: this.lookupForm.value.agency })
    this.branchOfficeService.editBranchOffice(lookup)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openDeleteLookupModal(modal, id) {
    this.lookupId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  deleteLookup() {
    this.branchOfficeService.deleteBranchOffice([this.lookupId])
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  clearFilters() {
    this.filterForm.reset({ name: '' })
    this.getAll();
  }

}
